import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  Typography,
  Divider,
  Avatar,
  Button,
} from "@mui/material";
import {
  Close,
  Home,
  Hiking,
  Backpack,
  TwoWheeler,
  DirectionsCar,
  Info,
} from "@mui/icons-material";

const drawerLinks = [
  { label: "Home", path: "/", icon: <Home /> },
  { label: "Trekking Tours", path: "/trekkingtours", icon: <Hiking /> },
  { label: "Tour Packages", path: "/tourpackages", icon: <Backpack /> },
  { label: "Motorcycle Tours", path: "/motorcycletours", icon: <TwoWheeler /> },
  { label: "Self Drive 4x4", path: "/selfdrive", icon: <DirectionsCar /> },
  { label: "About Us", path: "/aboutus", icon: <Info /> },
];

const CoolDrawer = ({ open, onClose, onNavigate }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 300,
          borderLeft: "none",
          background:
            "linear-gradient(180deg,#ffffff,#f0fdfa)",
        },
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          px: 2.5,
          py: 3,
          background:
            "linear-gradient(135deg,#0f766e,#14b8a6)",
          color: "#fff",
          position: "relative",
        }}
      >
        <Box
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "rgba(255,255,255,0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Close sx={{ fontSize: 18 }} />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Avatar
            sx={{
              bgcolor: "#ffffff",
              color: "#0f766e",
              fontWeight: 900,
            }}
          >
            G
          </Avatar>

          <Box>
            <Typography fontWeight={800}>
              Himachal Tours with Ajju
            </Typography>
            <Typography fontSize={12} sx={{ opacity: 0.85 }}>
              Explore • Travel • Discover
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* ================= NAVIGATION ================= */}
      <Box sx={{ flex: 1, py: 2 }}>
        <List disablePadding>
          {drawerLinks.map((item) => (
            <ListItem
              key={item.path}
              onClick={() => {
                onNavigate(item.path);
                onClose();
              }}
              sx={{
                mx: 2,
                mb: 1,
                borderRadius: 2,
                cursor: "pointer",
                transition: "all 0.25s ease",
                "&:hover": {
                  background:
                    "linear-gradient(135deg,#ecfeff,#f0fdfa)",
                  transform: "translateX(6px)",
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 44,
                }}
              >
                <Box
                  sx={{
                    width: 36,
                    height: 36,
                    borderRadius: "50%",
                    background:
                      "linear-gradient(135deg,#0f766e,#14b8a6)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                  }}
                >
                  {item.icon}
                </Box>
              </ListItemIcon>

              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontWeight: 700,
                  fontSize: "0.95rem",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider />

      {/* ================= FOOTER ================= */}
      <Box sx={{ p: 2 }}>
        <Button
          fullWidth
          variant="contained"
          sx={{
            fontWeight: 800,
            borderRadius: 2,
            background:
              "linear-gradient(135deg,#0f766e,#14b8a6)",
          }}
        >
          Enquire Now
        </Button>

        <Typography
          variant="caption"
          display="block"
          textAlign="center"
          sx={{ mt: 1, color: "#9ca3af" }}
        >
          © 2026 Himachal Tours with Ajju
        </Typography>
      </Box>
    </Drawer>
  );
};

export default CoolDrawer;
